<script setup lang="ts">
import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
  VisuallyHidden,
} from 'reka-ui'

import ElementsIconsChevron from '@/components/elements/icons/Chevron.vue'

const id = useId()

export type Props = {
  title?: string
  description?: string
  class?: HTMLDivElement['className']
  native?: boolean
}

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<Props>()

defineSlots<{
  default: any
  trigger: any
}>()

const open = ref(false)
</script>

<template>
  <DialogRoot v-model:open="open">
    <DialogTrigger as="span" :class="props.class || ''">
      <slot name="trigger"></slot>
    </DialogTrigger>

    <DialogPortal
      v-bind="native ? {} : { 'force-mount': true, disabled: true }"
    >
      <DialogOverlay
        class="bg-black/30 data-[state=open]:animate-overlayShow fixed inset-0 z-[1000] data-[state=closed]:opacity-0"
      />
      <DialogContent
        class="fixed top-0 right-0 w-full lg:w-[clamp(500px,35vw,525px)] data-[state=open]:animate-pane-show data-[state=closed]:animate-pane-hide h-screen z-[1000] shadow-[0px_14px_28px_0px_rgba(0,0,0,0.12)]"
      >
        <VisuallyHidden>
          <DialogTitle v-if="title">{{ title }}</DialogTitle>
        </VisuallyHidden>

        <VisuallyHidden>
          <DialogDescription v-if="description">
            {{ description }}
          </DialogDescription>
        </VisuallyHidden>

        <div
          class="w-full h-full lg:rounded-l-xl bg-crosswalk-200 text-action-primary px-[24px] lg:px-[48px] overflow-x-scroll"
        >
          <div class="pt-[32px] pb-[32px] sticky top-0 bg-crosswalk-200 z-20">
            <DialogClose
              as="button"
              class="cursor-pointer text-tertiary-950 flex items-center justify-start gap-x-[12px] font-[250] text-sm"
              aria-label="Luk"
            >
              <div
                class="flex items-center justify-center aspect-square w-[48px] rounded-full p-[8px] bg-tertiary/18"
              >
                <ElementsIconsChevron
                  class="rotate-180"
                  :stroke-color="'currentColor'"
                />
              </div>
              Tilbage
            </DialogClose>
          </div>
          <div>
            <div :id="id">
              <slot></slot>
            </div>
          </div>
        </div>
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
